import context from 'lib/stores/context';
import { useSnapshot } from 'valtio';
import styles from './index.module.scss';
import GlobalSummaryContent from './GlobalSummaryContent';
import RegionSummaryContent from './RegionSummaryContent';
import CountrySummaryContent from './CountrySummaryContent';

interface SidebarSummaryDataProps {
  title: string;
  statistics?: Array<{ label: string; value: string }>;
}

interface SidebarSummaryProps {
  summaryData?: SidebarSummaryDataProps;
}

const SidebarSummary = ({ summaryData }: SidebarSummaryProps) => {
  const { activeView } = useSnapshot(context);

  const renderContentForActiveView = () => {
    switch (activeView) {
      case 'worldwide':
        return <GlobalSummaryContent />;
      case 'region':
        return <RegionSummaryContent />;
      case 'country':
        return <CountrySummaryContent />;
      default:
        return <GlobalSummaryContent />;
    }
  };

  return (
    <>
      <div id='sidebar-summary' className={styles['sidebar-summary-container']}>
        {renderContentForActiveView()}
      </div>
    </>
  );
};

export default SidebarSummary;
